module.exports = __webpack_public_path__ + "static/img/fr.85556bea.svg";